<template>
  <b-modal ref="modal" hide-footer :title="user ? (user.full_name || user.name) : 'User'" @hidden="$emit('close')">
    <div v-if="user">
      <div class="d-flex align-items-center mb-3" style="gap:12px;">
        <div
          class="rounded-circle d-flex align-items-center justify-content-center text-white font-weight-bold flex-shrink-0"
          :style="{ background: '#0f172a', width:'48px', height:'48px', fontSize:'.9rem' }"
        >
          {{ initials }}
        </div>
        <div>
          <div class="font-weight-bold" style="color:#0f172a;">{{ user.full_name || user.name }}</div>
          <span v-if="user.role" class="pill">{{ user.role }}</span>
        </div>
      </div>

      <div class="detail-grid">
        <div class="detail-row">
          <span class="detail-label">Email</span>
          <span class="detail-value">{{ user.email || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Phone</span>
          <span class="detail-value">{{ user.phone || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Company</span>
          <span class="detail-value">{{ user.company ? user.company.name : '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Branch access</span>
          <span class="detail-value">{{ user.branch_count || 0 }} {{ user.branch_count === 1 ? 'branch' : 'branches' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Last active</span>
          <span class="detail-value">{{ formatDate(user.last_online) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Member since</span>
          <span class="detail-value">{{ formatDate(user.member_since) }}</span>
        </div>
      </div>

      <div class="d-flex mt-4" style="gap:8px;">
        <button
          v-if="user.company"
          class="btn btn-dark flex-grow-1"
          @click="$emit('view-company', user.company)"
        >
          <i class="bi bi-buildings mr-1"></i> View Company
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'AdminUserDetailModal',
  props: {
    user: { type: Object, default: null },
  },
  computed: {
    initials() {
      const name = this.user ? (this.user.full_name || this.user.name) : '';
      if (!name) return '?';
      const p = name.trim().split(' ');
      return p.length > 1 ? (p[0][0] + p[1][0]).toUpperCase() : p[0][0].toUpperCase();
    },
  },
  watch: {
    user(val) {
      if (val) this.$refs.modal.show();
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('D MMM YYYY, h:mm A') : '—';
    },
  },
};
</script>

<style scoped>
.pill {
  display: inline-block;
  background: #f1f5f9;
  color: #0f172a;
  font-size: .72rem;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
  margin-top: 4px;
}
.detail-grid {
  border-top: 1px solid #f1f5f9;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: .85rem;
}
.detail-label {
  color: #94a3b8;
}
.detail-value {
  color: #0f172a;
  font-weight: 500;
  text-align: right;
}
</style>
